<template>
  <div class="Ineliglible">
    <AppBar />
    <component
      :is="FindIneligibleFFormMetaData.componentName"
      :ref="FindIneligibleFFormMetaData.myRefNamer"
      :value="selectModel(getIneilgibleChppInput, undefined)"
      @input="
        (newValue) => updateModel(getIneilgibleChppInput, newValue, undefined)
      "
      v-bind="FindIneligibleFFormMetaData.props"
    ></component>
  </div>
</template>
<script lang="ts">
import { Vue, Component, Prop, Emit, Watch } from "vue-property-decorator";
import store, * as Store from "@/../src-gen/store";
import * as Data from "@/../src-gen/data";
import * as Action from "@/../src-gen/action";
import ModelVue from "@/components/ModelVue";
import AppBar from "@/components/bar/chppAppBar.vue";
import FindIneligibleFFormMDP from "./FindIneligibleFFormMDP";
import FForm from "@/components/form/FForm.vue";

@Component({
  components: {
    AppBar,
    FForm,
  },
})
export default class Ineligible extends ModelVue {
  getIneilgibleChppInput: Data.Partner.GetIneilgibleChppInput =
    new Data.Partner.GetIneilgibleChppInput();

  get FindIneligibleFFormMetaData() {
    return new FindIneligibleFFormMDP({
      parent: this,
    }).getMetaData();
  }

  getIneilgibleDashboard() {
    const routeData = this.$router.resolve({
      name: "CHPPRoot.MetabaseDashboardForIneligible",
      params: { dashboardId: "117" },
      query: {
        mobile:
          this.getIneilgibleChppInput?.customerPhoneNumber.toString(),
      },
    });
    window.open(routeData.href, "_blank");
  }
}
</script>

<style></style>
